import { useTranslation } from 'react-i18next';
import { GANTT_VIEW_TYPES } from '../../../shared/appConstants';
import DatePickerModal from '../../../shared/DatePickerModal';

const GanttDatePickerModal = ({ open, anchorEl, currentDate, viewType, selectedDates, onClose, onDateChange }) => {
  const { t } = useTranslation();

  const handleDateChange = (data) => {
    if (viewType === GANTT_VIEW_TYPES.DAY && Array.isArray(data)) {
      const newDate = new Date(data[0]);
      onDateChange(newDate, data);
    } else {
      onDateChange(data);
    }
  };

  const getModalProps = () => {
    switch (viewType) {
      case GANTT_VIEW_TYPES.DAY:
        return {
          mode: 'dateRange',
          title: t('gantt.selectDays'),
          minDays: 2,
          maxDays: 6,
          helperText: t('gantt.selectDaysInfo'),
          selectedDates
        };
      case GANTT_VIEW_TYPES.WEEK:
        return {
          mode: 'month',
          title: t('gantt.selectMonth'),
          currentDate
        };
      case GANTT_VIEW_TYPES.QUARTER:
        return {
          mode: 'quarter',
          title: t('gantt.selectQuarter'),
          currentDate
        };
      case GANTT_VIEW_TYPES.YEAR:
        return {
          mode: 'year',
          title: t('gantt.selectYear'),
          currentDate
        };
      default:
        return {};
    }
  };

  return (
    <DatePickerModal
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      onDateChange={handleDateChange}
      {...getModalProps()}
    />
  );
};

export default GanttDatePickerModal;
